import { useEffect, useRef } from 'react';

export const useTableArrowNav = (dataList, selector = '.arrow_target') => {
    const tableRef = useRef(null);

    useEffect(() => {
        const table = tableRef.current;
        if (!table) return;

        const handleKeyDown = (e) => {
            // 위 아래 방향키가 아닐 경우 이벤트 통과
            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;

            // 현재 테이블 내에서 포커스 이동 타겟이 되는 요소들 전부 수집
            const targets = Array.from(table.querySelectorAll(selector));
            if (targets.length === 0) return;

            // 현재 포커스가 가 있는 요소의 인덱스
            const activeIndex = targets.indexOf(document.activeElement);
            if (activeIndex === -1) return;

            e.preventDefault(); // 브라우저 스크롤이 같이 내려가는 현상 방지

            let nextIndex = activeIndex;

            // 위 아래 방향키로 이동: 마지막 행이면 처음으로, 처음 행이면 마지막으로 루프
            if (e.key === 'ArrowDown') {
                nextIndex = activeIndex === targets.length - 1 ? 0 : activeIndex + 1;
                // nextIndex = Math.min(activeIndex + 1, targets.length - 1); // 마지막 행이면 고정
            } else if (e.key === 'ArrowUp') {
                nextIndex = activeIndex === 0 ? targets.length - 1 : activeIndex - 1;
                // nextIndex = Math.max(activeIndex - 1, 0); // 처음 행이면 고정
            }

            // 계산된 다음 요소로 포커스를 강제 이동
            if(targets[nextIndex]) {
                targets[nextIndex].focus();
            }
        };

        table.addEventListener('keydown', handleKeyDown);
        return () => table.removeEventListener('keydown', handleKeyDown);

    }, [dataList, selector]);

    return tableRef;
};